import { wishListCardStyles } from "@insite/content-library/Components/WishListCard";
import { css } from "styled-components";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";

wishListCardStyles.gridContainer = {
    css: css`
        padding-bottom: 0px;
        div[class^="GridOffset"] {
            div[class^="GridItemStyle"] {
                div[class^="HiddenStyle"] {
                    span[class^="TypographyStyle"] {
                        white-space: nowrap;
                        font-size: 12px;
                    }
                }
            }
        }
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    null,
                    css`
                        div[class^="GridOffset"] {
                            div[class^="GridItemStyle"] {
                                div[class^="HiddenStyle"] {
                                    margin-right: 22px;
                                    span[class^="TypographyStyle"] {
                                        font-size: 10px;
                                        white-space: nowrap;
                                    }
                                }
                            }
                        }
                    `,
                    null,
                ],
                "minMax",
            )}
    `,
};
